<template>
  <div class="pot-page">
    <!-- Header -->
    <div class="pot-header">
      <div>
        <span class="pot-eyebrow">B2B</span>
        <h2 class="pot-title">Potencial Customers</h2>
      </div>
      <div>
        <b-button :variant="mapaVisible ? 'secondary' : 'outline-secondary'" class="mr-50" @click="toggleMapa">
          <i class="fa-solid fa-map-location-dot mr-25"></i> {{ mapaVisible ? 'Ocultar mapa' : 'Mapa y asistente IA' }}
        </b-button>
        <b-button variant="primary" @click="nuevo">
          <i class="fa-solid fa-plus mr-25"></i> Nuevo potencial
        </b-button>
      </div>
    </div>

    <!-- Formulario alta/edición -->
    <div v-if="showForm" class="pot-card mb-2">
      <div class="pot-card__header">
        <h3 class="pot-card__title">{{ form.id ? 'Editar potencial' : 'Nuevo potencial' }}</h3>
        <button class="pot-cerrar" @click="showForm = false"><i class="fa-solid fa-xmark mr-25"></i>Cerrar</button>
      </div>
      <div class="pot-form">
        <div class="field">
          <label class="field__label">Company name</label>
          <b-form-input size="sm" v-model="form.companyName" />
        </div>
        <div class="field">
          <label class="field__label">Nombre</label>
          <b-form-input size="sm" v-model="form.nombre" />
        </div>
        <div class="field">
          <label class="field__label">Apellidos</label>
          <b-form-input size="sm" v-model="form.apellidos" />
        </div>
        <div class="field">
          <label class="field__label">Email</label>
          <b-form-input size="sm" v-model="form.email" />
        </div>
        <div class="field">
          <label class="field__label">Telefono</label>
          <b-form-input size="sm" v-model="form.telefono" />
        </div>
        <div class="field">
          <label class="field__label">NIF</label>
          <b-form-input size="sm" v-model="form.nif" />
        </div>
        <div class="field">
          <label class="field__label">VAT</label>
          <b-form-input size="sm" v-model="form.vat" />
        </div>
        <div class="field field--span2">
          <label class="field__label">Direccion</label>
          <b-form-input size="sm" v-model="form.direccion" />
        </div>
        <div class="field">
          <label class="field__label">C.P.</label>
          <b-form-input size="sm" v-model="form.cp" />
        </div>
        <div class="field">
          <label class="field__label">Ciudad</label>
          <b-form-input size="sm" v-model="form.ciudad" />
        </div>
        <div class="field">
          <label class="field__label">Pais</label>
          <b-form-input size="sm" v-model="form.pais" />
        </div>
        <div class="field">
          <label class="field__label">Empresa</label>
          <v-select v-model="form.empresa" :options="['Harber London', 'Craft Lab']" class="select-styled" />
        </div>
        <div class="field">
          <label class="field__label">Estado</label>
          <v-select v-model="form.potencialEstado" :options="estados" class="select-styled" />
        </div>
        <div class="field field--span2">
          <label class="field__label">Web</label>
          <b-form-input size="sm" v-model="form.web" placeholder="https://..." />
        </div>
        <div class="field field--span2">
          <label class="field__label">Social media</label>
          <b-form-input size="sm" v-model="form.redes" placeholder="@usuario / enlaces" />
        </div>
        <div class="field field--span2">
          <label class="field__label">Notas</label>
          <b-form-textarea size="sm" rows="2" v-model="form.notas" />
        </div>
      </div>
      <div v-if="duplicadosForm.length" class="pot-duplicados">
        <i class="fa-solid fa-triangle-exclamation mr-50"></i>
        <div>
          <strong>Posible duplicado</strong>
          <div v-for="d in duplicadosForm" :key="d.p.id">
            {{ nombreDe(d.p) }} <span class="text-muted">({{ d.p.potencial ? `potencial · ${d.p.potencialEstado || 'Nuevo'}` : 'customer' }})</span>
            — coincide {{ d.motivos.join(', ') }}
          </div>
        </div>
      </div>
      <div class="pot-form__footer">
        <b-button variant="primary" :disabled="guardando || !nombreValido" @click="guardar">
          <b-spinner v-if="guardando" small class="mr-50" />
          {{ form.id ? 'Guardar cambios' : 'Crear potencial' }}
        </b-button>
      </div>
    </div>

    <!-- Mapa y asistente IA: se crean al abrirlos la primera vez; al ocultarlos se conserva su estado -->
    <div v-if="mapaCreado" v-show="mapaVisible">
    <!-- Mapa -->
    <div class="pot-card mb-2">
      <div class="pot-card__header">
        <h3 class="pot-card__title">Mapa</h3>
        <div class="pot-legend">
          <span v-for="(color, label) in leyenda" :key="label"><span class="pot-legend__dot" :style="{ background: color }"></span>{{ label }}</span>
          <span v-if="iaCiudades.length"><span class="pot-legend__dot" :style="{ background: colorIaCiudad }"></span>Ciudades IA</span>
          <span v-if="iaBarrios.length"><span class="pot-legend__dot" :style="{ background: colorIaBarrio }"></span>Barrios IA</span>
          <b-button size="sm" :variant="ventasVisibles ? 'primary' : 'outline-primary'" :disabled="cargandoVentas" @click="toggleVentas">
            <b-spinner v-if="cargandoVentas" small class="mr-50" />
            <i v-else class="fa-solid fa-bag-shopping mr-25"></i>
            {{ ventasVisibles ? 'Ocultar ventas' : 'Ventas últimos 6 meses' }}
          </b-button>
        </div>
      </div>
      <div ref="mapContainer" class="pot-map"></div>
    </div>

    <!-- Asistente IA -->
    <div class="pot-card mb-2">
      <div class="pot-card__header">
        <h3 class="pot-card__title"><i class="fa-solid fa-wand-magic-sparkles mr-50"></i>Asistente IA</h3>
        <b-button size="sm" variant="flat-secondary" @click="abrirPrompts">
          <i class="fa-solid fa-gear mr-25"></i> Prompts
        </b-button>
      </div>
      <div class="ia-body">
        <div class="ia-buscar">
          <v-select
            v-model="iaPais"
            :options="paisesMapa"
            taggable
            :loading="cargandoPaises"
            placeholder="País (los más centrados en el mapa primero)"
            @open="paisesVisibles"
            class="select-styled ia-buscar__pais"
          />
          <b-button size="sm" variant="primary" :disabled="!iaPais || iaCargando === 'ciudades'" @click="buscarCiudades(false)">
            <b-spinner v-if="iaCargando === 'ciudades'" small class="mr-50" />
            <i v-else class="fa-solid fa-city mr-25"></i> Buscar ciudades
          </b-button>
        </div>
        <div v-if="paisesGuardados.length" class="ia-guardados">
          <span class="ia-guardados__label"><i class="fa-solid fa-floppy-disk mr-25"></i>Guardadas:</span>
          <button
            v-for="p in paisesGuardados"
            :key="p"
            class="pill"
            :class="{ active: iaPaisBuscado === p }"
            :disabled="!!iaCargando"
            @click="iaPais = p; buscarCiudades(false)"
          >{{ p }}</button>
        </div>

        <div v-if="iaCiudades.length" class="ia-resultados">
          <div class="ia-col">
            <div class="ia-col__titulo">
              Ciudades · {{ iaPaisBuscado }}
              <span v-if="guardadas.ciudades" class="ia-guardada">
                guardada {{ fechaCorta(guardadas.ciudades) }}
                <button :disabled="!!iaCargando" title="Volver a preguntar a la IA" @click="buscarCiudades(true)"><i class="fa-solid fa-rotate-right"></i></button>
              </span>
            </div>
            <button
              v-for="(c, i) in iaCiudades"
              :key="c.nombre"
              class="ia-item"
              :class="{ active: iaCiudad === c.nombre }"
              :disabled="!!iaCargando"
              @click="buscarBarrios(c.nombre)"
            >
              <span class="ia-item__nombre"><span class="ia-num" :style="{ background: colorIaCiudad }">{{ i + 1 }}</span>{{ c.nombre }}</span>
              <small class="ia-item__motivo">{{ c.motivo }}</small>
            </button>
          </div>
          <div class="ia-col">
            <div class="ia-col__titulo">
              Barrios{{ iaCiudad ? ` · ${iaCiudad}` : '' }}
              <span v-if="guardadas.barrios" class="ia-guardada">
                guardada {{ fechaCorta(guardadas.barrios) }}
                <button :disabled="!!iaCargando" title="Volver a preguntar a la IA" @click="buscarBarrios(iaCiudad, true)"><i class="fa-solid fa-rotate-right"></i></button>
              </span>
            </div>
            <div v-if="iaCargando === 'barrios'" class="text-muted my-1"><b-spinner small class="mr-50" /> Consultando…</div>
            <div v-else-if="!iaBarrios.length" class="text-muted my-1">Elige una ciudad para ver sus barrios</div>
            <template v-else>
              <button
                v-for="(b, i) in iaBarrios"
                :key="b.nombre"
                class="ia-item"
                :class="{ active: iaBarrio === b.nombre }"
                @click="seleccionarBarrio(b)"
              >
                <span class="ia-item__nombre"><span class="ia-num" :style="{ background: colorIaBarrio }">{{ i + 1 }}</span>{{ b.nombre }}</span>
                <small class="ia-item__motivo">{{ b.motivo }}</small>
              </button>
            </template>
          </div>
          <div class="ia-col ia-col--tiendas">
            <div class="ia-col__titulo">
              Tiendas{{ iaBarrio ? ` · ${iaBarrio}` : '' }}{{ tiendas.length ? ` (${tiendasVisibles.length})` : '' }}
              <span v-if="guardadas.tiendas" class="ia-guardada">
                guardada {{ fechaCorta(guardadas.tiendas) }}
                <button :disabled="buscandoTiendas" title="Volver a buscar en Google Maps" @click="buscarTiendas(true)"><i class="fa-solid fa-rotate-right"></i></button>
              </span>
            </div>
            <button v-if="tiendasOcultas && !buscandoTiendas" class="ia-descartadas-toggle" @click="mostrarDescartadas = !mostrarDescartadas">
              {{ mostrarDescartadas ? `Ver solo las ${MAX_TIENDAS} mejores` : `Ver ${tiendasOcultas} más (peor puntuadas o descartadas por la IA)` }}
            </button>
            <div v-if="buscandoTiendas" class="text-muted my-1"><b-spinner small class="mr-50" /> Buscando en Google Maps y filtrando con IA…</div>
            <div v-else-if="!tiendasVisibles.length" class="text-muted my-1">
              {{ !iaBarrio ? 'Elige un barrio para ver sus tiendas' : tiendas.length ? 'Ninguna encaja según la IA' : 'Sin resultados' }}
            </div>
            <div v-else class="ia-lista">
              <div
                v-for="(t, i) in tiendasVisibles"
                :key="t.id"
                class="ia-item ia-item--tienda"
                :class="{ active: iaTienda === t.nombre, 'ia-item--descartada': t.encaja === false }"
                @click="verTienda(t)"
              >
                <div class="ia-tienda__info">
                  <span class="ia-item__nombre"><span class="ia-num" :style="{ background: colorIaTienda }">{{ i + 1 }}</span>{{ t.nombre }}</span>
                  <small v-if="t.motivo" class="ia-tienda__ia d-block">
                    <i class="fa-solid fa-wand-magic-sparkles mr-25"></i><strong v-if="t.puntuacion">{{ t.puntuacion }}/10 · </strong>{{ t.motivo }}
                  </small>
                  <small class="ia-item__motivo d-block">{{ t.direccionCompleta }}</small>
                  <div class="ia-meta">
                    <span v-if="t.rating" class="ia-chip ia-chip--rating"><i class="fa-solid fa-star"></i>{{ t.rating }} <span class="ia-chip__sub">({{ t.ratings }})</span></span>
                    <a v-if="t.web" :href="t.web" target="_blank" rel="noopener" class="ia-chip ia-chip--link" @click.stop><i class="fa-solid fa-globe"></i>Web</a>
                    <a v-if="t.mapsUrl" :href="t.mapsUrl" target="_blank" rel="noopener" class="ia-chip ia-chip--link" @click.stop><i class="fa-solid fa-location-dot"></i>Maps</a>
                    <span v-if="duplicados(t).length" class="ia-chip ia-chip--existe" :title="`Ya existe: ${nombreDe(duplicados(t)[0].p)}`">
                      <i class="fa-solid fa-circle-check"></i>Ya existe
                    </span>
                  </div>
                </div>
                <button class="ia-estrella" :class="{ on: esFavorita(t) }" :title="esFavorita(t) ? 'Quitar de favoritas' : 'Guardar en favoritas'" @click.stop="toggleFavorita(t)">
                  <i :class="esFavorita(t) ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="favoritas.length" class="ia-favoritas">
          <div class="ia-col__titulo"><i class="fa-solid fa-star mr-25" :style="{ color: colorFavorita }"></i>Tiendas favoritas ({{ favoritas.length }})</div>
          <div class="ia-favoritas__grid">
            <div
              v-for="t in favoritas"
              :key="t.id"
              class="ia-item ia-item--tienda"
              :class="{ active: iaTienda === t.nombre }"
              @click="verTienda(t)"
            >
              <div class="ia-tienda__info">
                <span class="ia-item__nombre">{{ t.nombre }}</span>
                <small class="ia-item__motivo d-block">{{ [t.barrio, t.ciudad].filter(Boolean).join(' · ') }}</small>
                <small v-if="t.motivo" class="ia-tienda__ia d-block"><i class="fa-solid fa-wand-magic-sparkles mr-25"></i>{{ t.motivo }}</small>
                <small class="ia-item__motivo d-block">{{ t.direccionCompleta }}</small>
                <div class="ia-meta">
                  <span v-if="t.rating" class="ia-chip ia-chip--rating"><i class="fa-solid fa-star"></i>{{ t.rating }} <span class="ia-chip__sub">({{ t.ratings }})</span></span>
                  <a v-if="t.web" :href="t.web" target="_blank" rel="noopener" class="ia-chip ia-chip--link" @click.stop><i class="fa-solid fa-globe"></i>Web</a>
                  <a v-if="t.mapsUrl" :href="t.mapsUrl" target="_blank" rel="noopener" class="ia-chip ia-chip--link" @click.stop><i class="fa-solid fa-location-dot"></i>Maps</a>
                </div>
              </div>
              <div class="ia-acciones">
                <button class="ia-estrella on" title="Quitar de favoritas" @click.stop="toggleFavorita(t)"><i class="fa-solid fa-star"></i></button>
                <span
                  v-if="duplicados(t).length"
                  class="ia-existe"
                  :title="`Ya existe: ${nombreDe(duplicados(t)[0].p)}`"
                ><i class="fa-solid fa-circle-check mr-25"></i>Ya existe</span>
                <b-button v-else size="sm" variant="flat-success" class="ia-anadir" title="Añadir como potencial" @click.stop="anadirTienda(t)">
                  <i class="fa-solid fa-plus mr-25"></i>Añadir
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="promptsVisible"
      title="Prompts del asistente"
      size="lg"
      ok-title="Guardar"
      cancel-title="Cancelar"
      :ok-disabled="promptsGuardando || Object.values(prompts).some(v => !(v || '').trim())"
      @ok.prevent="guardarPrompts"
    >
      <p class="text-muted small">Variables: <code>{pais}</code>, <code>{ciudad}</code> y <code>{barrio}</code>. El formato de la respuesta (y la lista de tiendas) lo añade el sistema.</p>
      <label class="field__label">Ciudades del país</label>
      <b-form-textarea v-model="prompts.ciudades" rows="5" class="mb-1" />
      <label class="field__label">Barrios de la ciudad</label>
      <b-form-textarea v-model="prompts.barrios" rows="5" class="mb-1" />
      <label class="field__label">Búsquedas de tiendas en Google Maps (una por línea)</label>
      <b-form-textarea v-model="prompts.terminos" rows="4" class="mb-1" />
      <label class="field__label">Filtro de tiendas (qué tiendas encajan)</label>
      <b-form-textarea v-model="prompts.tiendas" rows="6" />
    </b-modal>

    </div>

    <!-- Listado -->
    <div class="pot-card">
      <div class="pot-card__header">
        <h3 class="pot-card__title">Listado</h3>
        <div class="pot-filters">
          <div class="filter-pills">
            <button
              v-for="f in ['Todos', ...estados]"
              :key="f"
              class="pill"
              :class="{ active: estadoFiltro === f }"
              @click="estadoFiltro = f"
            >{{ f }}</button>
          </div>
          <div class="search-box">
            <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
            <input type="text" class="search-box__input" placeholder="Buscar potencial..." v-model="buscar" />
          </div>
        </div>
      </div>

      <div class="table-wrapper">
        <b-table
          :items="filtrados"
          :fields="columnas"
          class="mb-0"
          hover
          responsive
          show-empty
          :busy="cargando"
          empty-text="No hay potenciales"
          thead-class="table-head"
          tbody-tr-class="table-row"
        >
          <template #table-busy>
            <div class="text-center text-muted my-2">
              <b-spinner small class="mr-50" /> Cargando…
            </div>
          </template>

          <template #cell(nombre)="data">
            <div>
              <span class="font-weight-bold">{{ [data.item.nombre, data.item.apellidos].filter(Boolean).join(' ') || '—' }}</span>
              <i
                v-if="avisoGeo(data.item)"
                class="fa-solid fa-location-dot pot-sin-geo ml-25"
                :title="avisoGeo(data.item)"
              ></i>
              <small v-if="data.item.companyName" class="text-muted d-block">{{ data.item.companyName }}</small>
            </div>
          </template>

          <template #cell(email)="data">
            <span class="cell-mono">{{ data.item.email || '--' }}</span>
          </template>

          <template #cell(telefono)="data">
            <span class="cell-mono">{{ data.item.telefono || '--' }}</span>
          </template>

          <template #cell(pais)="data">
            {{ data.item.pais || '--' }}
          </template>

          <template #cell(potencialEstado)="data">
            <b-form-select
              :value="data.item.potencialEstado"
              :options="estados"
              size="sm"
              class="pot-estado"
              :class="`pot-estado--${claseEstado(data.item.potencialEstado)}`"
              @change="cambiarEstado(data.item, $event)"
            />
          </template>

          <template #cell(acciones)="data">
            <b-button size="sm" variant="flat-info" class="btn-icon" title="Historial / comentarios" @click="verComentarios(data.item)">
              <i class="fa-solid fa-comments"></i>
            </b-button>
            <b-button size="sm" variant="flat-primary" class="btn-icon" title="Editar" @click="editar(data.item)">
              <i class="fa-solid fa-pen"></i>
            </b-button>
            <b-button size="sm" variant="flat-success" class="btn-icon" title="Convertir en customer" @click="convertir(data.item)">
              <i class="fa-solid fa-user-check"></i>
            </b-button>
            <b-button size="sm" variant="flat-danger" class="btn-icon" title="Eliminar" @click="eliminar(data.item)">
              <i class="fa-solid fa-trash-can"></i>
            </b-button>
          </template>
        </b-table>
      </div>
    </div>

    <comentarios-pedido-modal ref="comentariosModal" />
  </div>
</template>

<script>
import {
  BButton, BTable, BSpinner, BFormInput, BFormTextarea, BFormSelect, BModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axios from '@axios'
import { MarkerClusterer } from '@googlemaps/markerclusterer'
import { AgrupadoViewport, renderer as rendererPedidos, marcadoresPedidos } from '@/utils/mapaPedidos'
import ComentariosPedidoModal from '@/components/ComentariosPedidoModal.vue'

const formVacio = () => ({
  id: null,
  companyName: '',
  nombre: '',
  apellidos: '',
  nif: '',
  vat: '',
  email: '',
  telefono: '',
  direccion: '',
  cp: '',
  ciudad: '',
  pais: '',
  web: '',
  redes: '',
  notas: '',
  empresa: 'Harber London',
  potencialEstado: 'Nuevo',
})

const COLOR_CUSTOMER = '#10B981'
const COLOR_POTENCIAL = '#FFFFFF'
const COLOR_PERDIDO = '#EF4444'
const COLOR_NEGOCIACION = '#F59E0B'

const colorPin = p => {
  if (!p.potencial) return COLOR_CUSTOMER
  if (p.potencialEstado === 'Perdido') return COLOR_PERDIDO
  if (p.potencialEstado === 'En negociación') return COLOR_NEGOCIACION
  return COLOR_POTENCIAL
}

// Chincheta con borde y sombra suave; la blanca lleva borde gris para verse sobre el mapa
const iconoPin = color => {
  const blanca = color === COLOR_POTENCIAL
  const borde = blanca ? '#94A3B8' : '#FFFFFF'
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="42" viewBox="0 0 30 42">
    <defs><filter id="s" x="-50%" y="-50%" width="200%" height="200%"><feDropShadow dx="0" dy="1.5" stdDeviation="1.5" flood-opacity=".35"/></filter></defs>
    <path filter="url(#s)" d="M15 2.5C8.1 2.5 2.5 8 2.5 14.8 2.5 24 15 38.5 15 38.5S27.5 24 27.5 14.8C27.5 8 21.9 2.5 15 2.5z" fill="${color}" stroke="${borde}" stroke-width="2"/>
    <circle cx="15" cy="14.8" r="4.5" fill="${blanca ? '#94A3B8' : '#FFFFFF'}"/>
  </svg>`
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: new google.maps.Size(30, 42),
    anchor: new google.maps.Point(15, 39),
  }
}

// Por encima de los grupos de productos vendidos (MAX_ZINDEX + nº de pedidos)
const Z_CUSTOMERS = 1e7
// Resultados del asistente IA: por encima de todo
const Z_IA = 2e7
const COLOR_IA_CIUDAD = '#7367F0'
const COLOR_IA_BARRIO = '#0EA5E9'

const COLOR_IA_TIENDA = '#EC4899'
const COLOR_FAVORITA = '#EAB308'
// Tiendas que se enseñan por barrio (las mejor puntuadas por la IA)
const MAX_TIENDAS = 20

// ---------- Duplicados: mismo email, web, teléfono, nombre o a menos de 50 m ----------
const REDES = ['instagram.com', 'facebook.com', 'linktr.ee', 'tiktok.com', 'linkedin.com']
const normTxt = t => (t || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '')
const normWeb = w => {
  const host = (w || '').toLowerCase().replace(/^https?:\/\//, '').replace(/^www\./, '').split(/[/?#]/)[0]
  return REDES.includes(host) ? '' : host
}
const normTel = t => (t || '').replace(/\D/g, '').slice(-9)
const distanciaM = (a, b) => {
  const rad = x => (x * Math.PI) / 180
  const h = Math.sin(rad(b.lat - a.lat) / 2) ** 2
    + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(rad(b.lng - a.lng) / 2) ** 2
  return 2 * 6371000 * Math.asin(Math.sqrt(h))
}
const posDe = p => (p.pos || (p.lat != null && p.lng != null ? { lat: Number(p.lat), lng: Number(p.lng) } : null))
const motivosDuplicado = (a, b) => {
  const m = []
  if (a.email && normTxt(a.email) === normTxt(b.email)) m.push('email')
  if (normWeb(a.web) && normWeb(a.web) === normWeb(b.web)) m.push('web')
  if (normTel(a.telefono).length >= 7 && normTel(a.telefono) === normTel(b.telefono)) m.push('teléfono')
  if (normTxt(a.companyName).length >= 4 && normTxt(a.companyName) === normTxt(b.companyName)) m.push('nombre')
  const pa = posDe(a)
  const pb = posDe(b)
  if (pa && pb && distanciaM(pa, pb) < 50) m.push('ubicación')
  return m
}

// Círculo numerado de los resultados IA; el seleccionado, más grande
const iconoIA = (color, activo) => {
  const t = activo ? 34 : 26
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${t}" height="${t}" viewBox="0 0 40 40"><defs><filter id="s" x="-50%" y="-50%" width="200%" height="200%"><feDropShadow dx="0" dy="1.5" stdDeviation="1.5" flood-opacity=".35"/></filter></defs><circle filter="url(#s)" cx="20" cy="20" r="16" fill="${color}" stroke="#FFFFFF" stroke-width="3"/></svg>`
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: new google.maps.Size(t, t),
    anchor: new google.maps.Point(t / 2, t / 2),
  }
}

// Grupo de chinchetas cercanas: círculo oscuro con el número de chinchetas
const iconoGrupo = {
  url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><defs><filter id="s" x="-50%" y="-50%" width="200%" height="200%"><feDropShadow dx="0" dy="1.5" stdDeviation="1.5" flood-opacity=".35"/></filter></defs><circle filter="url(#s)" cx="20" cy="20" r="16" fill="#1E293B" stroke="#FFFFFF" stroke-width="2.5"/></svg>',
  )}`,
}
const rendererGrupo = {
  render: ({ count, position }) => new google.maps.Marker({
    position,
    icon: { ...iconoGrupo, scaledSize: new google.maps.Size(40, 40), anchor: new google.maps.Point(20, 20) },
    label: { text: String(count), color: '#FFFFFF', fontSize: '13px', fontWeight: '700' },
    zIndex: Z_CUSTOMERS + count,
  }),
}

// Varias chinchetas en las mismas coordenadas (p. ej. geocodificadas al centro de la ciudad) no se
// separan con zoom: se reparten en un círculo de ~80 m alrededor del punto
const separarDuplicados = posiciones => {
  const grupos = {}
  posiciones.forEach((pos, i) => {
    if (!pos) return
    const k = `${pos.lat.toFixed(5)},${pos.lng.toFixed(5)}`
    if (!grupos[k]) grupos[k] = []
    grupos[k].push(i)
  })
  return posiciones.map((pos, i) => {
    if (!pos) return null
    const grupo = grupos[`${pos.lat.toFixed(5)},${pos.lng.toFixed(5)}`]
    if (grupo.length === 1) return pos
    const ang = (2 * Math.PI * grupo.indexOf(i)) / grupo.length
    return { lat: pos.lat + 0.0008 * Math.cos(ang), lng: pos.lng + 0.0008 * Math.sin(ang) }
  })
}

// Place de Google (Places API New) -> tienda con los campos del formulario de potencial
const tiendaDePlace = pl => {
  const comp = tipo => {
    const c = (pl.addressComponents || []).find(x => x.types.includes(tipo))
    return c ? c.longText : ''
  }
  return {
    id: pl.id,
    nombre: pl.displayName,
    companyName: pl.displayName,
    tipos: pl.types || [],
    direccionCompleta: pl.formattedAddress,
    direccion: [comp('route'), comp('street_number')].filter(Boolean).join(' ') || pl.formattedAddress,
    cp: comp('postal_code'),
    ciudad: comp('locality') || comp('postal_town'),
    pais: comp('country'),
    telefono: pl.internationalPhoneNumber || '',
    web: pl.websiteURI || '',
    mapsUrl: pl.googleMapsURI,
    rating: pl.rating,
    ratings: pl.userRatingCount,
    pos: pl.location ? { lat: pl.location.lat(), lng: pl.location.lng() } : null,
  }
}

// Geocoding en el navegador (la API key de Maps es la del front); el resultado se guarda en customers
const geocoder = () => geocoder.g || (geocoder.g = new google.maps.Geocoder())
const geocodificar = address => geocoder().geocode({ address })
  .then(({ results }) => {
    const loc = results[0] && results[0].geometry.location
    return loc ? { lat: loc.lat(), lng: loc.lng() } : null
  })
  .catch(e => (e && e.code === 'ZERO_RESULTS' ? null : undefined)) // undefined = error temporal, no guardar

export default {
  components: {
    BButton, BTable, BSpinner, BFormInput, BFormTextarea, BFormSelect, BModal, vSelect, ComentariosPedidoModal,
  },
  data() {
    return {
      potenciales: [],
      customers: [],
      map: null,
      clusterer: null,
      mapaCreado: false,
      mapaVisible: false,
      ventasClusterer: null,
      ventasVisibles: false,
      cargandoVentas: false,
      paisesMapa: [],
      cargandoPaises: false,
      iaPais: null,
      iaPaisBuscado: '',
      iaCiudades: [],
      iaCiudad: '',
      iaBarrios: [],
      iaBarrio: '',
      colorIaCiudad: COLOR_IA_CIUDAD,
      colorIaBarrio: COLOR_IA_BARRIO,
      colorIaTienda: COLOR_IA_TIENDA,
      colorFavorita: COLOR_FAVORITA,
      guardadas: { ciudades: null, barrios: null, tiendas: null }, // fecha de guardado de lo que se ve
      paisesGuardados: [],
      favoritas: [],
      mostrarDescartadas: false,
      MAX_TIENDAS,
      tiendas: [],
      iaTienda: '',
      buscandoTiendas: false,
      iaCargando: '',
      promptsVisible: false,
      promptsGuardando: false,
      prompts: {
        ciudades: '', barrios: '', terminos: '', tiendas: '',
      },
      promptsOriginales: {},
      leyenda: {
        Customers: COLOR_CUSTOMER,
        'Potencial Customers': COLOR_POTENCIAL,
        'Potencial Perdido': COLOR_PERDIDO,
        'En Negociación': COLOR_NEGOCIACION,
      },
      cargando: true,
      guardando: false,
      showForm: false,
      buscar: '',
      estadoFiltro: 'Todos',
      estados: ['Nuevo', 'Contactado', 'En negociación', 'Ganado', 'Perdido', 'Inactivo'],
      form: formVacio(),
      columnas: [
        { key: 'nombre', label: 'Potencial', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'telefono', label: 'Telefono' },
        { key: 'pais', label: 'Pais', sortable: true },
        { key: 'potencialEstado', label: 'Estado', sortable: true, thStyle: { width: '170px' } },
        {
          key: 'acciones', label: '', class: 'text-nowrap', thStyle: { width: '190px' },
        },
      ],
    }
  },
  computed: {
    // Las MAX_TIENDAS mejor puntuadas de las que encajan (o todas, si se piden). tiendas ya viene ordenada
    tiendasVisibles() {
      return this.mostrarDescartadas ? this.tiendas : this.tiendas.filter(t => t.encaja !== false).slice(0, MAX_TIENDAS)
    },
    tiendasOcultas() {
      return this.tiendas.length - this.tiendas.filter(t => t.encaja !== false).slice(0, MAX_TIENDAS).length
    },
    duplicadosForm() {
      return this.duplicados(this.form)
    },
    nombreValido() {
      return !!(this.form.nombre || this.form.companyName || '').trim()
    },
    filtrados() {
      const q = this.buscar.toLowerCase().trim()
      return this.potenciales.filter(p => {
        if (this.estadoFiltro !== 'Todos' && p.potencialEstado !== this.estadoFiltro) return false
        if (!q) return true
        const campos = [p.nombre, p.apellidos, p.companyName, p.email, p.telefono, p.ciudad, p.pais, p.web]
        return campos.some(c => c != null && c.toString().toLowerCase().includes(q))
      })
    },
  },
  methods: {
    load() {
      this.cargando = true
      axios
        .get('/customers/potenciales')
        .then(({ data }) => {
          this.potenciales = data || []
          this.pintarMapa()
        })
        .catch(() => { this.notificar('No se pudieron cargar los potenciales', 'danger') })
        .finally(() => { this.cargando = false })
    },
    cargarCustomers() {
      if (!this.customersPromesa) {
        this.customersPromesa = axios.get('/customers')
          .then(({ data }) => { this.customers = data || [] })
          .catch(() => { this.customersPromesa = null })
      }
      return this.customersPromesa
    },
    // Customers y potenciales que parecen el mismo que c: [{ p, motivos }]
    duplicados(c) {
      return [...this.customers, ...this.potenciales]
        .filter(p => !c.id || p.id !== c.id)
        .map(p => ({ p, motivos: motivosDuplicado(c, p) }))
        .filter(d => d.motivos.length)
    },
    nombreDe(p) {
      return p.companyName || [p.nombre, p.apellidos].filter(Boolean).join(' ')
    },
    nuevo() {
      this.cargarCustomers()
      this.form = formVacio()
      this.showForm = true
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    editar(p) {
      this.cargarCustomers()
      this.form = { ...formVacio(), ...p, potencialEstado: p.potencialEstado || 'Nuevo' }
      this.showForm = true
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    guardar() {
      this.guardando = true
      const payload = { ...this.form, potencial: 1 }
      const req = this.form.id
        ? axios.post('/customers/update', payload)
        : axios.post('/customers', payload)
      req
        .then(() => {
          this.notificar(this.form.id ? 'Potencial actualizado' : 'Potencial creado')
          this.showForm = false
          this.load()
        })
        .catch(() => { this.notificar('No se pudo guardar', 'danger') })
        .finally(() => { this.guardando = false })
    },
    cambiarEstado(p, estado) {
      axios
        .post('/customers/update', { ...p, potencialEstado: estado })
        .then(() => {
          this.$set(p, 'potencialEstado', estado)
          this.pintarMapa()
          this.notificar(`${p.nombre || p.companyName}: ${estado}`)
        })
        .catch(() => { this.notificar('No se pudo cambiar el estado', 'danger') })
    },
    verComentarios(p) {
      this.$refs.comentariosModal.abrir(p, {
        base: '/customers',
        titulo: p.companyName || [p.nombre, p.apellidos].filter(Boolean).join(' '),
      })
    },
    convertir(p) {
      this.$bvModal
        .msgBoxConfirm(`"${p.companyName || p.nombre}" pasará a la lista de customers. ¿Continuar?`, {
          title: 'Convertir en customer', okTitle: 'Convertir', cancelTitle: 'Cancelar', okVariant: 'success', centered: true,
        })
        .then(ok => {
          if (!ok) return
          axios
            .post('/customers/convertir', { id: p.id })
            .then(() => {
              this.notificar('Convertido en customer')
              this.load()
            })
            .catch(() => { this.notificar('No se pudo convertir', 'danger') })
        })
    },
    eliminar(p) {
      this.$bvModal
        .msgBoxConfirm(`¿Eliminar el potencial "${p.companyName || p.nombre}"?`, {
          title: 'Confirmar', okTitle: 'Eliminar', cancelTitle: 'Cancelar', okVariant: 'danger', centered: true,
        })
        .then(ok => {
          if (!ok) return
          axios
            .post('/customers/delete', p)
            .then(() => {
              this.notificar('Potencial eliminado')
              this.load()
            })
            .catch(() => { this.notificar('No se pudo eliminar', 'danger') })
        })
    },
    claseEstado(estado) {
      if (estado === 'Ganado') return 'ok'
      if (estado === 'Perdido') return 'ko'
      if (estado === 'En negociación') return 'neg'
      if (estado === 'Contactado') return 'con'
      if (estado === 'Inactivo') return 'off'
      return 'nuevo'
    },
    // Pedidos de los últimos 6 meses con la foto del artículo, como el mapa de /
    async toggleVentas() {
      if (this.ventasVisibles) {
        this.ventasClusterer.clearMarkers()
        this.ventasVisibles = false
        return
      }
      this.cargandoVentas = true
      try {
        const fmt = d => d.toISOString().slice(0, 10)
        const desde = new Date()
        desde.setMonth(desde.getMonth() - 6)
        const { data } = await axios.get('/map/orders', { params: { from: `${fmt(desde)} 00:00:00`, to: `${fmt(new Date())} 23:59:59` } })
        if (!this.ventasClusterer) {
          this.ventasClusterer = new MarkerClusterer({
            map: this.map,
            algorithm: new AgrupadoViewport({ maxZoom: 18, radius: 100, viewportPadding: 200 }),
            renderer: rendererPedidos,
          })
        }
        this.ventasClusterer.addMarkers(marcadoresPedidos(data || []))
        this.ventasVisibles = true
      } catch (e) {
        this.notificar('No se pudieron cargar las ventas', 'danger')
      } finally {
        this.cargandoVentas = false
      }
    },
    // Países que se ven en el mapa: país de 9 puntos de la vista, del centro hacia fuera
    // (el mar no devuelve país). Se calcula al abrir el desplegable, no al mover el mapa
    async paisesVisibles() {
      const bounds = this.map.getBounds()
      if (!bounds) return
      const ne = bounds.getNorthEast()
      const sw = bounds.getSouthWest()
      let ancho = ne.lng() - sw.lng()
      if (ancho < 0) ancho += 360
      const fracciones = [0.5, 1 / 6, 5 / 6]
      const puntos = []
      fracciones.forEach(fy => fracciones.forEach(fx => puntos.push({ fx, fy })))
      puntos.sort((a, b) => ((a.fx - 0.5) ** 2 + (a.fy - 0.5) ** 2) - ((b.fx - 0.5) ** 2 + (b.fy - 0.5) ** 2))

      this.cargandoPaises = true
      const paises = await Promise.all(puntos.map(({ fx, fy }) => geocoder()
        .geocode({ location: new google.maps.LatLng(sw.lat() + (ne.lat() - sw.lat()) * fy, sw.lng() + ancho * fx) })
        .then(({ results }) => {
          const comp = results.flatMap(r => r.address_components).find(c => c.types.includes('country'))
          return comp && comp.long_name
        })
        .catch(() => null)))
      this.paisesMapa = [...new Set(paises.filter(Boolean))]
      this.cargandoPaises = false
    },
    async consultarIA(clave, body) {
      this.iaCargando = clave
      try {
        const { data } = await axios.post(`/ia/prospeccion/${clave}`, body)
        return data.items || []
      } catch (e) {
        this.notificar('No se pudo consultar la IA', 'danger')
        return null
      } finally {
        this.iaCargando = ''
      }
    },
    // Resultado guardado de una búsqueda o null. La clave compara sin mayúsculas (collation de MySQL)
    leerGuardado(tipo, clave) {
      return axios.get('/ia/prospeccion/busquedas', { params: { tipo, clave } })
        .then(({ data }) => (data && data.items ? data : null))
        .catch(() => null)
    },
    guardarBusqueda(tipo, clave, items) {
      axios.put('/ia/prospeccion/busquedas', { tipo, clave, items }).catch(() => {})
      return new Date()
    },
    fechaCorta(d) {
      return new Date(d).toLocaleDateString()
    },
    // forzar = volver a preguntar a la IA aunque haya una búsqueda guardada
    async buscarCiudades(forzar = false) {
      const pais = (this.iaPais || '').trim()
      if (!pais) return
      let items
      let fecha
      const guardado = !forzar && await this.leerGuardado('ciudades', pais)
      if (guardado) {
        ({ items } = guardado)
        fecha = guardado.updatedAt
      } else {
        items = await this.consultarIA('ciudades', { pais })
        if (!items) return
        await this.posicionar(items, c => `${c.nombre}, ${pais}`)
        fecha = this.guardarBusqueda('ciudades', pais, items)
        if (!this.paisesGuardados.some(p => p.toLowerCase() === pais.toLowerCase())) this.paisesGuardados.unshift(pais)
      }
      this.guardadas = { ciudades: fecha, barrios: null, tiendas: null }
      this.iaPaisBuscado = pais
      this.iaCiudades = items
      this.iaCiudad = ''
      this.iaBarrio = ''
      this.iaBarrios = []
      this.tiendas = []
      this.pintarIA()
    },
    // Añade pos { lat, lng } a cada resultado de la IA (null si Google no lo encuentra)
    posicionar(items, direccion) {
      return Promise.all(items.map(it => geocodificar(direccion(it)).then(pos => { it.pos = pos || null })))
    },
    pintarIA() {
      this.iaMarcadores.forEach(m => m.setMap(null))
      const crear = (items, color, activo, onClick, etiqueta = i => String(i + 1)) => items.map((it, i) => {
        if (!it.pos) return null
        const act = it.nombre === activo
        const m = new google.maps.Marker({
          map: this.map,
          position: it.pos,
          title: it.nombre,
          icon: iconoIA(color, act),
          label: { text: etiqueta(i), color: '#FFFFFF', fontSize: act ? '13px' : '11px', fontWeight: '700' },
          zIndex: Z_IA + (act ? 1 : 0),
        })
        m.addListener('click', () => onClick(it))
        return m
      }).filter(Boolean)
      this.iaMarcadores = [
        ...crear(this.iaCiudades, COLOR_IA_CIUDAD, this.iaCiudad, c => !this.iaCargando && this.buscarBarrios(c.nombre)),
        ...crear(this.iaBarrios, COLOR_IA_BARRIO, this.iaBarrio, b => this.seleccionarBarrio(b)),
        ...crear(this.tiendasVisibles, COLOR_IA_TIENDA, this.iaTienda, t => this.verTienda(t)),
        // Favoritas que no están ya en la lista de tiendas actual
        ...crear(this.favoritas.filter(f => !this.tiendasVisibles.some(t => t.id === f.id)), COLOR_FAVORITA, this.iaTienda, f => this.verTienda(f), () => '★'),
      ]
    },
    seleccionarBarrio(b) {
      this.irA(`${b.nombre}, ${this.iaCiudad}, ${this.iaPaisBuscado}`, b.nombre)
      this.buscarTiendas(false)
    },
    esFavorita(t) {
      return this.favoritas.some(f => f.id === t.id)
    },
    toggleFavorita(t) {
      if (this.esFavorita(t)) {
        axios.delete(`/ia/prospeccion/favoritas/${encodeURIComponent(t.id)}`)
          .then(() => {
            this.favoritas = this.favoritas.filter(f => f.id !== t.id)
            this.pintarIA()
          })
          .catch(() => { this.notificar('No se pudo quitar de favoritas', 'danger') })
        return
      }
      // barrio de la búsqueda en la que se marcó (el de Google no siempre viene)
      const fav = { ...t, barrio: t.barrio || this.iaBarrio }
      axios.post('/ia/prospeccion/favoritas', fav)
        .then(() => {
          this.favoritas.unshift(fav)
          this.pintarIA()
        })
        .catch(() => { this.notificar('No se pudo guardar en favoritas', 'danger') })
    },
    verTienda(t) {
      this.iaTienda = t.nombre
      this.pintarIA()
      if (!t.pos) return
      this.map.setCenter(t.pos)
      this.map.setZoom(17)
      this.$refs.mapContainer.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    // Tiendas reales del barrio con Places API (New): la IA dice dónde buscar, Google qué hay
    // Varias búsquedas en Google Places (términos editables) sin duplicados; después la IA marca cuáles encajan
    async buscarTiendas(forzar = false) {
      const barrio = this.iaBarrio
      const ciudad = this.iaCiudad
      const pais = this.iaPaisBuscado
      if (!barrio) return
      this.buscandoTiendas = true
      this.tiendas = []
      this.iaTienda = ''
      this.mostrarDescartadas = false
      this.guardadas = { ...this.guardadas, tiendas: null }
      try {
        const { data: prompts } = await axios.get('/ia/prospeccion/prompts')
        const terminos = (prompts.terminos || '').split('\n').map(t => t.trim()).filter(Boolean)
        const clave = [pais, ciudad, barrio, terminos.join(',')].join('|')

        const guardado = !forzar && await this.leerGuardado('tiendas', clave)
        if (guardado) {
          if (this.iaBarrio !== barrio) return
          this.tiendas = guardado.items
          this.guardadas = { ...this.guardadas, tiendas: guardado.updatedAt }
          return
        }

        const { Place } = await google.maps.importLibrary('places')
        const busquedas = await Promise.allSettled(terminos.map(termino => Place.searchByText({
          textQuery: `${termino} in ${barrio}, ${ciudad}, ${pais}`,
          fields: ['id', 'displayName', 'types', 'formattedAddress', 'addressComponents', 'location', 'internationalPhoneNumber',
            'websiteURI', 'googleMapsURI', 'rating', 'userRatingCount'],
          maxResultCount: 20,
        })))
        if (busquedas.every(r => r.status === 'rejected')) throw busquedas[0].reason
        const vistos = new Set()
        const candidatas = busquedas
          .flatMap(r => (r.status === 'fulfilled' ? r.value.places : []))
          .filter(pl => !vistos.has(pl.id) && vistos.add(pl.id))
          .map(tiendaDePlace)

        let tiendas = candidatas
        if (candidatas.length) {
          try {
            const { data } = await axios.post('/ia/prospeccion/tiendas', {
              pais,
              ciudad,
              barrio,
              tiendas: candidatas.map(t => ({
                id: t.id, nombre: t.nombre, tipos: t.tipos, web: t.web, direccion: t.direccionCompleta,
              })),
            })
            const veredictos = {}
            const items = data.items || []
            items.forEach(v => { veredictos[v.id] = v })
            // Si la IA se salta alguna, se muestra (mejor revisar de más que perderla)
            tiendas = candidatas
              .map(t => {
                const v = veredictos[t.id] || {}
                return {
                  ...t, encaja: v.encaja !== false, puntuacion: Number(v.puntuacion) || 0, motivo: v.motivo || '',
                }
              })
              .sort((a, b) => (Number(b.encaja) - Number(a.encaja)) || (b.puntuacion - a.puntuacion))
          } catch (e) {
            this.notificar('La IA no pudo filtrar las tiendas: se muestran todas', 'warning')
          }
        }
        if (this.iaBarrio !== barrio) return
        this.tiendas = tiendas
        this.guardadas = { ...this.guardadas, tiendas: this.guardarBusqueda('tiendas', clave, tiendas) }
      } catch (e) {
        console.error('buscarTiendas:', e)
        this.notificar('No se pudieron buscar tiendas (¿Places API activada?)', 'danger')
      } finally {
        this.buscandoTiendas = false
        this.pintarIA()
      }
    },
    anadirTienda(t) {
      this.form = {
        ...formVacio(),
        companyName: t.companyName,
        direccion: t.direccion,
        cp: t.cp,
        ciudad: t.ciudad,
        pais: t.pais,
        telefono: t.telefono,
        web: t.web,
        notas: t.mapsUrl ? `Google Maps: ${t.mapsUrl}` : '',
        pos: t.pos, // solo para detectar duplicados por ubicación; el backend lo ignora
      }
      this.showForm = true
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    // Centra el mapa en la ciudad o barrio (viewport que devuelve Google) y sube hasta el mapa
    irA(address, barrio = '') {
      this.iaBarrio = barrio
      this.pintarIA()
      geocoder().geocode({ address })
        .then(({ results }) => {
          const { viewport, location } = results[0].geometry
          if (viewport) this.map.fitBounds(viewport)
          else { this.map.setCenter(location); this.map.setZoom(barrio ? 15 : 12) }
          this.$refs.mapContainer.scrollIntoView({ behavior: 'smooth', block: 'center' })
        })
        .catch(() => { this.notificar(`No se encontró "${address}" en el mapa`, 'warning') })
    },
    async buscarBarrios(ciudad, forzar = false) {
      this.irA(`${ciudad}, ${this.iaPaisBuscado}`)
      this.iaCiudad = ciudad
      this.iaBarrio = ''
      this.iaBarrios = []
      this.tiendas = []
      this.guardadas = { ...this.guardadas, barrios: null, tiendas: null }
      this.pintarIA()
      const pais = this.iaPaisBuscado
      const clave = `${pais}|${ciudad}`
      let items
      let fecha
      const guardado = !forzar && await this.leerGuardado('barrios', clave)
      if (guardado) {
        ({ items } = guardado)
        fecha = guardado.updatedAt
      } else {
        items = await this.consultarIA('barrios', { pais, ciudad })
        if (!items) return
        await this.posicionar(items, b => `${b.nombre}, ${ciudad}, ${pais}`)
        fecha = this.guardarBusqueda('barrios', clave, items)
      }
      if (this.iaCiudad !== ciudad) return
      this.iaBarrios = items
      this.guardadas = { ...this.guardadas, barrios: fecha }
      this.pintarIA()
    },
    abrirPrompts() {
      axios.get('/ia/prospeccion/prompts')
        .then(({ data }) => {
          this.prompts = { ...data }
          this.promptsOriginales = { ...data }
          this.promptsVisible = true
        })
        .catch(() => { this.notificar('No se pudieron cargar los prompts', 'danger') })
    },
    guardarPrompts() {
      const cambiados = Object.keys(this.prompts).filter(k => this.prompts[k] !== this.promptsOriginales[k])
      this.promptsGuardando = true
      Promise.all(cambiados.map(k => axios.put(`/ia/prospeccion/prompts/${k}`, { prompt: this.prompts[k] })))
        .then(() => {
          this.notificar('Prompts guardados')
          this.promptsVisible = false
        })
        .catch(() => { this.notificar('No se pudieron guardar los prompts', 'danger') })
        .finally(() => { this.promptsGuardando = false })
    },
    direccionGeo(p) {
      return [p.direccion, p.cp, p.ciudad, p.pais].filter(Boolean).join(', ')
    },
    // Texto del aviso si el potencial no sale en el mapa ('' = sí sale o aún se está geocodificando)
    avisoGeo(p) {
      const address = this.direccionGeo(p)
      if (!address) return 'Sin dirección: no aparece en el mapa'
      if (p.geoAddress === address && p.lat == null) return 'Dirección no encontrada: no aparece en el mapa'
      return ''
    },
    async toggleMapa() {
      this.mapaVisible = !this.mapaVisible
      if (this.mapaCreado) return
      this.mapaCreado = true
      await this.$nextTick()
      await window.googleMapsReady
      this.map = new google.maps.Map(this.$refs.mapContainer, { center: { lat: 45, lng: -2 }, zoom: 3 })
      this.clusterer = new MarkerClusterer({ map: this.map, renderer: rendererGrupo })
      this.iaMarcadores = [] // fuera de data: objetos de Google Maps
      axios.get('/ia/prospeccion/busquedas/paises').then(({ data }) => { this.paisesGuardados = data || [] }).catch(() => {})
      axios.get('/ia/prospeccion/favoritas')
        .then(({ data }) => {
          this.favoritas = data || []
          this.pintarIA()
        })
        .catch(() => {})
      await this.cargarCustomers()
      this.pintarMapa()
    },
    async pintarMapa() {
      if (!this.map) return
      const todos = [...this.customers, ...this.potenciales]
      const posiciones = []
      // En serie: el Geocoder del navegador limita las peticiones por segundo
      for (const p of todos) {
        const address = this.direccionGeo(p)
        if (!address) { posiciones.push(null); continue }
        if (p.geoAddress === address) {
          posiciones.push(p.lat != null ? { lat: Number(p.lat), lng: Number(p.lng) } : null)
          continue
        }
        const pos = await geocodificar(address)
        if (pos !== undefined) {
          Object.assign(p, { lat: pos && pos.lat, lng: pos && pos.lng, geoAddress: address })
          axios.put(`/customers/${p.id}/geo`, { lat: p.lat, lng: p.lng, geoAddress: address }).catch(() => {})
        }
        posiciones.push(pos || null)
      }
      const separadas = separarDuplicados(posiciones)
      const marcadores = todos
        .map((p, i) => separadas[i] && new google.maps.Marker({
          position: separadas[i],
          icon: iconoPin(colorPin(p)),
          zIndex: Z_CUSTOMERS,
          title: `${p.companyName || [p.nombre, p.apellidos].filter(Boolean).join(' ')}${p.potencial ? ` (${p.potencialEstado || 'Nuevo'})` : ''}`,
        }))
        .filter(Boolean)
      this.clusterer.clearMarkers()
      this.clusterer.addMarkers(marcadores)
    },
    notificar(msg, variant = 'success') {
      this.$bvToast.toast(msg, { title: 'Potenciales', variant, solidColor: true })
    },
  },
  mounted() {
    axios.post('/uso', { seccion: 'potencial-customers' }).catch(() => {})
    this.load()
  },
}
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$success: #10B981;
$danger: #EF4444;
$warning: #F59E0B;
$text: #1E293B;
$text-muted: #64748B;
$border: #E2E8F0;

.pot-page { padding-bottom: 24px; }

.pot-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.pot-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
}

.pot-title {
  margin: 0;
  font-weight: 700;
  color: $text;
}

.pot-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 8px;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    padding: 14px 16px;
    border-bottom: 1px solid $border;
  }

  &__title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: $text;
  }
}

.pot-cerrar {
  border: none;
  background: none;
  font-size: 12px;
  font-weight: 600;
  color: $text-muted;
  cursor: pointer;

  &:hover { color: $danger; }
}

.pot-form {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px 14px;
  padding: 16px;

  @media (max-width: 992px) { grid-template-columns: repeat(2, 1fr); }
}

.field {
  &--span2 { grid-column: span 2; }

  &__label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: $text-muted;
    margin-bottom: 2px;
    display: block;
  }
}

.pot-form__footer {
  padding: 0 16px 16px;
  text-align: right;
}

.pot-filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-pills {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.pill {
  border: 1px solid $border;
  background: #fff;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  color: $text-muted;
  cursor: pointer;

  &.active {
    background: $primary;
    border-color: $primary;
    color: #fff;
  }
}

.search-box {
  position: relative;

  &__icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: $text-muted;
  }

  &__input {
    border: 1px solid $border;
    border-radius: 6px;
    padding: 6px 10px 6px 30px;
    font-size: 13px;
    min-width: 220px;

    &:focus { outline: none; border-color: $primary; }
  }
}

.table-wrapper { overflow-x: auto; }

.ia-body { padding: 16px; }

.ia-buscar {
  display: flex;
  gap: 10px;
  align-items: center;

  &__pais { flex: 1; max-width: 360px; }
}

.ia-resultados {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-top: 16px;

  @media (max-width: 1200px) { grid-template-columns: 1fr 1fr; }
  @media (max-width: 768px) { grid-template-columns: 1fr; }
}

.ia-col__titulo {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: $text-muted;
  margin-bottom: 6px;
}

.ia-item {
  display: block;
  width: 100%;
  text-align: left;
  background: #fff;
  border: 1px solid $border;
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 6px;
  cursor: pointer;

  &:hover:not(:disabled):not(.ia-item--static) { border-color: $primary; }
  &.active { border-color: $primary; background: rgba($primary, 0.06); }

  &__nombre { display: block; font-weight: 600; color: $text; }
  &__motivo { color: $text-muted; }
}

.ia-tienda__ia {
  color: #7367F0;
  margin: 1px 0;
}

.ia-item--descartada { opacity: 0.55; }

.ia-descartadas-toggle {
  border: none;
  background: none;
  padding: 0;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: $primary;
  cursor: pointer;
  text-align: left;
}

.ia-resultados .ia-col { min-width: 0; }

// Las tiendas (hasta 20) no estiran la fila: la columna toma la altura de ciudades/barrios
// (height 0 + flex-grow) y la lista hace scroll
.ia-col--tiendas {
  display: flex;
  flex-direction: column;
}

.ia-lista {
  flex: 1 1 auto;
  height: 0;
  min-height: 320px;
  overflow-y: auto;
  padding-right: 4px;
}

.ia-item--tienda {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
}

.ia-tienda__info { flex: 1; min-width: 0; }

.ia-anadir { flex-shrink: 0; white-space: nowrap; }

.ia-acciones {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
}

.ia-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.ia-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 9px;
  border-radius: 11px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  border: 1px solid $border;
  background: #F8FAFC;
  color: $text;

  i { font-size: 10px; }

  &__sub { font-weight: 500; color: $text-muted; }

  &--rating i { color: #EAB308; }

  &--link {
    color: $primary;
    text-decoration: none;
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover {
      background: rgba($primary, 0.08);
      border-color: rgba($primary, 0.4);
      color: $primary;
      text-decoration: none;
    }
  }

  &--existe {
    border-color: rgba($success, 0.35);
    background: rgba($success, 0.08);
    color: darken($success, 8%);
  }
}

.ia-estrella {
  border: none;
  background: none;
  padding: 2px 6px;
  font-size: 15px;
  color: $text-muted;
  cursor: pointer;

  &.on, &:hover { color: #EAB308; }
}

.ia-guardada {
  margin-left: 6px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;

  button {
    border: none;
    background: none;
    padding: 0 4px;
    color: $primary;
    cursor: pointer;

    &:disabled { opacity: 0.4; cursor: default; }
  }
}

.ia-guardados {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 10px;

  &__label {
    font-size: 12px;
    font-weight: 600;
    color: $text-muted;
  }
}

.ia-favoritas {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid $border;

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0 16px;

    @media (max-width: 1200px) { grid-template-columns: 1fr 1fr; }
    @media (max-width: 768px) { grid-template-columns: 1fr; }
  }
}

.ia-existe {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: $success;
  white-space: nowrap;
  padding-top: 4px;
}

.pot-duplicados {
  display: flex;
  align-items: flex-start;
  margin: 0 16px 12px;
  padding: 10px 12px;
  border-radius: 6px;
  background: rgba($warning, 0.12);
  color: darken($warning, 25%);
  font-size: 13px;
}

.ia-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-right: 8px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
}

.pot-sin-geo { color: $danger; cursor: help; }

.pot-map { height: 450px; border-radius: 0 0 8px 8px; }

.pot-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 12px;
  font-weight: 600;
  color: $text-muted;

  &__dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 6px;
    border-radius: 50%;
    border: 1px solid $text;
  }
}

.cell-mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
}

.pot-estado {
  font-weight: 600;

  &--nuevo { color: $text-muted; }
  &--con { color: $primary; }
  &--neg { color: darken($warning, 8%); }
  &--ok { color: $success; }
  &--ko { color: $danger; }
  &--off { color: #b9b9c3; }
}
</style>

<!-- vue-select necesita estilos sin scope -->
<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';

.pot-page {
  .select-styled {
    .vs__dropdown-toggle {
      min-height: 31px;
      padding: 0 0 2px 0;
      border-radius: 8px;
      border: 1px solid #E2E8F0;
      transition: border-color 0.15s ease;
    }

    .vs__search {
      font-size: 13px;
    }

    &.vs--open .vs__dropdown-toggle {
      border-color: #3B82F6;
      box-shadow: 0 0 0 3px rgba(#3B82F6, 0.1);
    }
  }
}

// ══════════ DARK MODE ══════════
.dark-layout .pot-page {
  .pot-title { color: #e4e6eb; }
  .pot-eyebrow { color: #8e9099; }

  .pot-card { background: #1f1f1f; border-color: #2c2c2c; box-shadow: none; }
  .pot-card__header { border-bottom-color: #2c2c2c; }
  .pot-card__title { color: #e4e6eb; }
  .pot-cerrar { color: #8e9099; &:hover { color: #EF4444; } }
  .field__label, .ia-col__titulo, .ia-guardados__label, .pot-legend { color: #8e9099; }

  // Filtros y buscador
  .pill { background: #161616; border-color: #2c2c2c; color: #b4b7bd; }
  .pill.active { background: #3B82F6; border-color: #3B82F6; color: #fff; }
  .search-box__input { background: #161616; border-color: #2c2c2c; color: #d0d2d6; &:focus { border-color: #3B82F6; } }

  // Asistente IA
  .ia-item { background: #161616; border-color: #2c2c2c; }
  .ia-item:hover:not(:disabled):not(.ia-item--static) { border-color: #3B82F6; }
  .ia-item.active { border-color: #3B82F6; background: rgba(59, 130, 246, 0.1); }
  .ia-item__nombre { color: #e4e6eb; }
  .ia-item__motivo, .ia-chip__sub, .ia-estrella { color: #8e9099; }
  .ia-estrella.on, .ia-estrella:hover { color: #EAB308; }
  .ia-chip { background: #242424; border-color: #2c2c2c; color: #d0d2d6; }
  .ia-chip--link { color: #3B82F6; &:hover { background: rgba(59, 130, 246, 0.12); border-color: rgba(59, 130, 246, 0.4); } }
  .ia-chip--existe { background: rgba(16, 185, 129, 0.1); border-color: rgba(16, 185, 129, 0.35); color: #10B981; }
  .ia-favoritas { border-top-color: #2c2c2c; }
  .pot-duplicados { color: #F59E0B; }

  .select-styled .vs__dropdown-toggle { background: #161616; border-color: #2c2c2c; }
  .select-styled .vs__selected, .select-styled .vs__search { color: #d0d2d6; }
  .select-styled .vs__dropdown-menu { background: #242424; border-color: #3a3a3a; }
  .select-styled .vs__dropdown-option { color: #d0d2d6; }
  .select-styled .vs__dropdown-option--highlight { background: #2c2c2c; color: #fff; }
  .select-styled.vs--open .vs__dropdown-toggle { border-color: #3B82F6; }

  // Tabla
  .table { background: #1f1f1f !important; }
  .table thead th { background: #1f1f1f !important; color: #6e7079 !important; border-bottom-color: #2c2c2c !important; }
  .table tbody tr { background: #1f1f1f !important; }
  .table tbody tr td { border-top-color: #2c2c2c !important; color: #d0d2d6 !important; }
  .table tbody tr:hover { background: #242424 !important; }
}
</style>
